import { Outlet } from 'react-router-dom';
import { StoreProvider } from '../state/store-context.js';
import { Sidebar } from './Sidebar.js';
import { Topbar } from './Topbar.js';

export function AppShell(): JSX.Element {
  return (
    <StoreProvider>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'var(--sidebar-w) 1fr',
          minHeight: '100vh',
        }}
      >
        <Sidebar />
        <main style={{ minWidth: 0 }}>
          <Topbar />
          <div
            style={{
              padding: '24px 28px 60px',
              maxWidth: 1320,
              width: '100%',
              margin: '0 auto',
            }}
          >
            <Outlet />
          </div>
        </main>
      </div>
    </StoreProvider>
  );
}
